import { cn } from '@shared/lib/cn';

/**
 * Stilisierter „Florian-Helm" als SVG-Logo.
 * Bewusst abstrakt, hochwertig, monoton (nutzt currentColor).
 */
export function Logo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={cn('text-accent-500', className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M16 4c5.523 0 10 4.029 10 9 0 1.36-.245 2.66-.69 3.85L26.5 22h-2.4l-.65-2.31a8 8 0 0 1-14.9 0L7.9 22H5.5l1.19-5.15A11 11 0 0 1 6 13c0-4.971 4.477-9 10-9Z"
        fill="currentColor"
        fillOpacity="0.92"
      />
      <path
        d="M11.5 14h9c.276 0 .5.224.5.5v.5c0 1.5-1.5 3-5 3s-5-1.5-5-3v-.5c0-.276.224-.5.5-.5Z"
        fill="rgb(var(--bg-0))"
        fillOpacity="0.85"
      />
      <rect x="14.4" y="22" width="3.2" height="6" rx="0.8" fill="currentColor" fillOpacity="0.92" />
    </svg>
  );
}
